import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_recurring_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_plan_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_actual_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_property_json: fromDatatype.JsonDatatypeInterface;
  recurring_notification_json: fromDatatype.JsonDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  status_server: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  status_client: fromDatatype.VarcharDatatypeInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy: boolean;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  doc_desc: fromDatatype.VarcharDatatypeInterface;
  doc_remarks: fromDatatype.VarcharDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: any;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_cogs: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  amount_gst_balance: fromDatatype.NumericDatatypeInterface;
  amount_wht_balance: fromDatatype.NumericDatatypeInterface;
  amount_internal_settlement: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_guid: fromDatatype.GuidDataFieldInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  posting_inventory: fromDatatype.VarcharDatatypeInterface;
  posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_tax_gst: fromDatatype.VarcharDatatypeInterface;
  posting_tax_wht: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  posting_cashbook: fromDatatype.VarcharDatatypeInterface;
  posting_sales_commission_queue: fromDatatype.VarcharDatatypeInterface;
  posting_bundle: fromDatatype.VarcharDatatypeInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  arap_doc_open: fromDatatype.NumericDatatypeInterface;
  arap_contra: fromDatatype.NumericDatatypeInterface;
  arap_bal: fromDatatype.NumericDatatypeInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  delivery_preferences: fromDatatype.VarcharDatatypeInterface;
  delivery_time_preferred: fromDatatype.VarcharDatatypeInterface;
  delivery_date_preferred: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_expected: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.JsonDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  ready_to_ship: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  generated_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_contract_folder_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_recurring_generic_doc_hdr_RowClass
  implements bl_fi_recurring_generic_doc_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_plan_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_actual_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_property_json: fromDatatype.JsonDatatypeInterface;
  recurring_notification_json: fromDatatype.JsonDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  status_server: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  status_client: fromDatatype.VarcharDatatypeInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy: boolean;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  doc_desc: fromDatatype.VarcharDatatypeInterface;
  doc_remarks: fromDatatype.VarcharDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: any;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_cogs: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  amount_gst_balance: fromDatatype.NumericDatatypeInterface;
  amount_wht_balance: fromDatatype.NumericDatatypeInterface;
  amount_internal_settlement: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_guid: fromDatatype.GuidDataFieldInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  posting_inventory: fromDatatype.VarcharDatatypeInterface;
  posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_tax_gst: fromDatatype.VarcharDatatypeInterface;
  posting_tax_wht: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  posting_cashbook: fromDatatype.VarcharDatatypeInterface;
  posting_sales_commission_queue: fromDatatype.VarcharDatatypeInterface;
  posting_bundle: fromDatatype.VarcharDatatypeInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  arap_doc_open: fromDatatype.NumericDatatypeInterface;
  arap_contra: fromDatatype.NumericDatatypeInterface;
  arap_bal: fromDatatype.NumericDatatypeInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  delivery_preferences: fromDatatype.VarcharDatatypeInterface;
  delivery_time_preferred: fromDatatype.VarcharDatatypeInterface;
  delivery_date_preferred: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_expected: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.JsonDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  ready_to_ship: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  generated_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_contract_folder_guid: fromDatatype.GuidDataFieldInterface;
}
